var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.999 511.999",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#80E471"
    },
    d: "M129.844,255.364c-40.545-63.82-96.272-64.553-98.625-64.553H4.744l8.811,24.966 c32.897,93.206,0.14,199.344-0.189,200.388l-7.752,24.402h137.704l1.426-20.198C150.547,338.228,153.742,292.981,129.844,255.364z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00925B"
    },
    d: "M498.444,215.776l8.811-24.966H480.78c-2.353,0-58.08,0.733-98.625,64.553 c-23.898,37.617-20.702,82.864-14.902,165.004l1.426,20.198h137.704l-7.752-24.402C498.297,415.107,465.424,309.332,498.444,215.776 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00C47A"
    },
    d: "M248.914,413.111c-0.347-0.663-35.242-68.591-81.156-263.725l-11.433-48.59l-23.356,44.116 c-2.534,4.785-61.763,119.04-37.457,279.726l2.409,15.929h134.417l30.922-0.04L248.914,413.111z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#60DD4D"
    },
    d: "M293.561,176.51c-21.966-56.522-46.571-89.304-47.607-90.671l-29.846-39.382l-3.76,49.271 c-14.462,189.531-60.655,305.43-61.115,306.568l-10.479,25.784h182.001l1.818-16.705 C335.469,311.252,313.722,228.39,293.561,176.51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#60DD4D"
    },
    d: "M366.185,165.564l-29.84-44.338l-4.371,53.264c-6.255,76.241-36.156,135.392-60.138,171.587 c-26.239,39.604-51.385,61.275-51.61,61.466l-38.963,33.021h232.157l1.572-17.007C429.895,262.341,368.794,169.44,366.185,165.564z "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00C47A"
    },
    d: "M293.561,176.51c-13.577-34.936-28.156-60.788-37.561-75.772v327.342h66.755l1.818-16.705 C335.469,311.252,313.722,228.39,293.561,176.51z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrass);
export default __webpack_public_path__ + "static/media/grass.10b9edef74416955453ec087f901dbd0.svg";
export { ForwardRef as ReactComponent };